var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrderHistoryActiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1663 1.75H6.83375C3.64875 1.75 1.75 3.64875 1.75 6.83375V14.1575C1.75 17.3513 3.64875 19.25 6.83375 19.25H14.1575C17.3425 19.25 19.2412 17.3513 19.2412 14.1663V6.83375C19.25 3.64875 17.3513 1.75 14.1663 1.75ZM13.7812 13.7812H7.21875C6.86 13.7812 6.5625 13.4837 6.5625 13.125C6.5625 12.7663 6.86 12.4688 7.21875 12.4688H13.7812C14.14 12.4688 14.4375 12.7663 14.4375 13.125C14.4375 13.4837 14.14 13.7812 13.7812 13.7812ZM13.7812 8.53125H7.21875C6.86 8.53125 6.5625 8.23375 6.5625 7.875C6.5625 7.51625 6.86 7.21875 7.21875 7.21875H13.7812C14.14 7.21875 14.4375 7.51625 14.4375 7.875C14.4375 8.23375 14.14 8.53125 13.7812 8.53125Z",
    fill: "#465C8E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderHistoryActiveIcon);
export default __webpack_public_path__ + "static/media/order-history-active-icon.39e7394720b25145a261b09987d51c52.svg";
export { ForwardRef as ReactComponent };